import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ceres-discard-dialog',
    templateUrl: './discard-dialog.component.html',
    styleUrls: ['./discard-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DiscardDialogComponent {
    data = inject<{
        text: string;
        header: string;
        disableClose: boolean;
        confirmButtonText: string;
    }>(MAT_DIALOG_DATA);
    private matDialogRef = inject<MatDialogRef<DiscardDialogComponent>>(MatDialogRef);

    public cancel() {
        this.matDialogRef.close();
    }

    public confirm() {
        this.matDialogRef.close(true);
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.matDialogRef.close();
    }
}
